module.exports = __webpack_public_path__ + "static/media/IMG_20181114_212536_edited.04b5c7a5.jpg";